export const BHU_CARD_HEADING =
  'Recognizing Bullying & Harassment Unit for Grades 6-8'
export const BHU_LESSONS_COMPLETED = '% of Lessons Completed in Grades 6-8'
